<script setup>
</script>
<template>
  <div class="page-container new_article_design">
    <section class="blog-article-section">
      <article class="blog-article">
        <div class="container">
          <div class="single-article-wrapper">
            <div class="blog-post-date">December 13, 2024</div>
            <h1 class="article-title">
              Tools to power your trades and investments: December 2024
            </h1>
            <div class="article-cat">
              Blog |
              <a
                href="/market-talk/category/product-update/"
                rel="category tag"
                >PRODUCT UPDATE</a
              >
            </div>
            <div class="single-article-featured-img">
              <img
                width="937"
                height="534"
                src="https://upstox.com/app/uploads/2024/12/image-60.png"
                class="secondary-thumbnail"
                alt=""
                loading="lazy"
                srcset="
                  https://upstox.com/app/uploads/2024/12/image-60.png         937w,
                  https://upstox.com/app/uploads/2024/12/image-60-300x171.png 300w,
                  https://upstox.com/app/uploads/2024/12/image-60-768x438.png 768w,
                  https://upstox.com/app/uploads/2024/12/image-60-50x28.png    50w
                "
                sizes="(max-width: 937px) 100vw, 937px"
              />
            </div>
            <div class="single-article-content">
              <p>
                <span style="font-weight: 400"
                  >As 2024 comes to a close, we’re giving your trading
                  experience a final boost with some game-changing updates.
                  Here’s what’s new to help you finish the year strong and start
                  off 2025 with a bang!</span
                >
              </p>
              <p>
                <span style="font-weight: 400"
                  ><br />
                  💜</span
                ><strong>Major updates on ‘Upstox Pro for traders’</strong>
              </p>
              <strong> </strong>
              <p><strong></strong></p>
              <p>
                <span style="text-decoration: underline"
                  ><strong
                    >NSE Commodities are now LIVE&nbsp; on our platform
                    🎉</strong
                  ></span
                >
              </p>
              <p>
                <span style="font-weight: 400"
                  >If you're already trading in a segment on one Exchange, you
                  can now trade in the same segment on others too! For example,
                  if you've activated Commodities on MCX, you'll automatically
                  have access to Commodities on NSE as well.&nbsp;</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <img
                  loading="lazy"
                  class="alignnone wp-image-49773 size-full"
                  src="https://upstox.com/app/uploads/2024/12/Frame-1244836706.jpg"
                  alt=""
                  width="1197"
                  height="677"
                  srcset="
                    https://upstox.com/app/uploads/2024/12/Frame-1244836706.jpg          1197w,
                    https://upstox.com/app/uploads/2024/12/Frame-1244836706-300x170.jpg   300w,
                    https://upstox.com/app/uploads/2024/12/Frame-1244836706-1024x579.jpg 1024w,
                    https://upstox.com/app/uploads/2024/12/Frame-1244836706-768x434.jpg   768w,
                    https://upstox.com/app/uploads/2024/12/Frame-1244836706-50x28.jpg      50w
                  "
                  sizes="(max-width: 1197px) 100vw, 1197px"
                />
              </p>
              <p>
                <span style="text-decoration: underline"
                  ><strong
                    ><br />
                    Introducing Picture-in-Picture (PiP) Mode 🚀</strong
                  ></span
                >
              </p>
              <p>
                <span style="font-weight: 400"
                  >Now analyse charts, browse market news, or even enjoy a
                  coffee break—all while staying updated on your positions in
                  real-time. Yes! That’s exactly what the PiP mode lets you
                  do!&nbsp;</span
                >
              </p>
              <p>
                It’s<span style="font-weight: 400">
                  a feature that lets you keep important info in a floating
                  window, so you can multitask without switching between
                  apps.</span
                >
              </p>
              <p><strong>Why you’ll love PiP mode:</strong></p>
              <p>
                <strong>📊 Real-Time Updates</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> Get LIVE P&amp;L updates</span
                ><span style="font-weight: 400"><br /> </span
                ><strong>⚙️ Easy Activation</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> Enable PiP via ‘My Profile’ or the
                  Positions tab</span
                >
              </p>
              <p>
                <img
                  loading="lazy"
                  class="alignnone wp-image-49767 size-full"
                  src="https://upstox.com/app/uploads/2024/12/image-57.jpg"
                  alt=""
                  width="1680"
                  height="879"
                  srcset="
                    https://upstox.com/app/uploads/2024/12/image-57.jpg          1680w,
                    https://upstox.com/app/uploads/2024/12/image-57-300x157.jpg   300w,
                    https://upstox.com/app/uploads/2024/12/image-57-1024x536.jpg 1024w,
                    https://upstox.com/app/uploads/2024/12/image-57-768x402.jpg   768w,
                    https://upstox.com/app/uploads/2024/12/image-57-50x26.jpg      50w,
                    https://upstox.com/app/uploads/2024/12/image-57-1536x804.jpg 1536w
                  "
                  sizes="(max-width: 1680px) 100vw, 1680px"
                />
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400">💜</span
                ><strong>Minor updates on ‘Upstox Pro for traders’</strong>
              </p>
              <p>
                <strong
                  ><br />
                  Pro on iPad:</strong
                >
                <span style="font-weight: 400"
                  >Upstox Pro now supports Option Chain, charts, and watchlists
                  in landscape mode on iPad. Enjoy a smoother trading experience
                  on a larger screen.</span
                >
              </p>
              <p>
                <strong>Right Entitlement (RE) Nudge:</strong>
                <span style="font-weight: 400"
                  >A new nudge helps you easily spot Right Entitlement (RE)
                  scrips in your holdings and orders, eliminating confusion
                  during trading.</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400"
                  >That’s all folks! Hope these new features help you improve
                  your trading and investment journey. Our dev, product, design
                  teams have worked super hard to bring you these updates – if
                  you love them, don’t forget to share a review on Playstore and
                  App Store – it will make their day 🫶</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="download-App">
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/apple-icon.png"
                alt="apple-icon"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>iOS App</h3>
            </div>
          </a>
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/play-store-icon.png"
                alt="play-store"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>Android App</h3>
            </div>
          </a>
        </div>
      </article>
    </section>
  </div>
</template>
<style scoped>
</style>
